export var CONTENT_WIDTH = 520;
export var CONTAINER_PADDING_TOP_KUZCO = 75;
export var EXTRA_PADDINGS = 30;
export var DESKTOP_ICON_SIZE = 70;
export var LARGE_CONTENT_WIDTH = 680;
export var SIDEBAR_WIDTH = 300;
export var SIDE_PADDINGS = 20;
//# sourceMappingURL=constants.js.map